import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import Home from 'modules/Home/Home';
import {useCallback} from 'react';

function HomePageElement() {
  const {updateHeaderData} = useRouteBuildContext();
  const handleHeaderData = useCallback(
    ({icon, action, iconTitle, badgeNumber}: HeaderDataPayload) => {
      updateHeaderData('home', {icon, action, iconTitle, badgeNumber});
    },
    [updateHeaderData]
  );

  return <Home headerData={handleHeaderData} />;
}

export function createHomeRoute(): PageRouteConfig {
  return {
    element: <HomePageElement />,
    layout: {
      title: 'نما',
      hasNavigate: true,
      hasHeader: true,
      hasBack: false,
      hasLeftIcon: false,
      headerDataKey: 'home',
      badge: true,
      badgeNumber: 1
    },
    initialHeaderData: {
      home: {icon: '', iconTitle: '', action: null, title: '', badgeNumber: 0}
    }
  };
}
